/**
 * @description 审批申请Api
 */

import request from "@/utils/request";

// 申请/重新发起申请
export const postCreateInfo = (data) =>
  request({
    method: "POST",
    url: "approveinfo/create",
    data,
  });

// 获取申请记录
export const getRecordList = (data) =>
  request({
    method: "POST",
    url: "approveinfo/get_list",
    data,
  });

// 获取申请详情
export const getDetail = (data) =>
  request({
    method: "POST",
    url: "approveinfo/get_detail",
    data,
  });

// 获取申请信息 - 重新发起时使用
export const getInfo = (data) =>
  request({
    method: "POST",
    url: "approveinfo/get_info",
    data,
  });

// 催办
export const putUrging = (data) =>
  request({
    method: "POST",
    url: "approveinfo/urging",
    data,
  });

// 撤销
export const putCancel = (data) =>
  request({
    method: "POST",
    url: "approveinfo/cancel",
    data,
  });

// 更新维修评价
export const postEvaluate = (data) =>
  request({
    method: "POST",
    url: "approveinfo/comment",
    data,
  });

export const downloadPdf = (data) =>
  request({
    method: "POST",
    url: "approveinfo/download",
    data,
  });
